const CONSTANTS = {
    Cosmos: {
        Timestamps: {
            GenesisTimestamp: '2025-11-30T00:00:00.000Z',
        },
        RoleNames: {
            ErrorOutput: 'ErrorOutput',
        },
        BooleanResources: {
            BOOLEAN_FALSE: 'RESOURCE-BOOLEAN:False',
            BOOLEAN_TRUE: 'RESOURCE-BOOLEAN:True',
        },
    },
    Names: {
        BaseResource: 'BaseResource',
        BaseTracePoint: 'BaseTracePoint',
        Boolean: 'Boolean',
        BranchStep: 'BranchStep',
        Case: 'Case',
        Description: 'Description',
        DescriptionFacet: 'DescriptionFacet',
        DocumentationSpec: 'DocumentationSpec',
        Embedding: 'Embedding',
        Error: 'Error',
        ExternalInputPotential: 'ExternalInputPotential',
        ForStep: 'ForStep',
        GenesisProvenance: 'GenesisProvenance',
        Goal: 'Goal',
        GoalHandle: 'GoalHandle',
        InputPotential: 'InputPotential',
        InternalInputPotential: 'InternalInputPotential',
        JsonScalarLink: 'JsonScalarLink',
        JsonSchemaObject: 'JsonSchemaObject',
        LoopCase: 'LoopCase',
        LoopFeedbackBindingSpec: 'LoopFeedbackBindingSpec',
        LoopStep: 'LoopStep',
        MacroStep: 'MacroStep',
        MacroStepContext: 'MacroStepContext',
        MacroStepSlot: 'MacroStepSlot',
        MaterializedResource: 'MaterializedResource',
        Name: 'Name',
        NameFacet: 'NameFacet',
        Natural: 'Natural',
        Provenance: 'Provenance',
        ProvenanceFacet: 'ProvenanceFacet',
        ProvenanceKind: 'ProvenanceKind',
        Resource: 'Resource',
        ResourceId: 'ResourceId',
        ResourcePointer: 'ResourcePointer',
        ResourceType: 'ResourceType',
        ResourceTypeHandle: 'ResourceTypeHandle',
        Role: 'Role',
        RoleBindingSpec: 'RoleBindingSpec',
        RoleBindingSpecFacet: 'RoleBindingSpecFacet',
        RoleByName: 'RoleByName',
        RoleName: 'RoleName',
        RoleNameArray: 'RoleNameArray',
        RoleSpec: 'RoleSpec',
        RoleSpecFacet: 'RoleSpecFacet',
        RuntimeProvenance: 'RuntimeProvenance',
        Step: 'Step',
        StepArray: 'StepArray',
        StepArrayArray: 'StepArrayArray',
        StepKind: 'StepKind',
        StepKindFacet: 'StepKindFacet',
        StepPath: 'StepPath',
        StepPathRelocation: 'StepPathRelocation',
        StepPathRelocationArray: 'StepPathRelocationArray',
        StepPathSegment: 'StepPathSegment',
        StepPathSegmentKind: 'StepPathSegmentKind',
        StepPathSlot: 'StepPathSlot',
        StepPathSpec: 'StepPathSpec',
        StepsByThreadIndexFacet: 'StepsByThreadIndexFacet',
        StepsFacet: 'StepsFacet',
        Suite: 'Suite',
        SuiteIngestorInputSchema: 'SuiteIngestorInputSchema',
        SuspendedTracePoint: 'SuspendedTracePoint',
        TickKind: 'TickKind',
        TickTracePoint: 'TickTracePoint',
        TimestampedResource: 'TimestampedResource',
        Tool: 'Tool',
        ToolHandle: 'ToolHandle',
        ToolStep: 'ToolStep',
        ToolStepRoleAddress: 'ToolStepRoleAddress',
        TracePoint: 'TracePoint',
        TracePointCounterSnapshot: 'TracePointCounterSnapshot',
        TracePointDelta: 'TracePointDelta',
        TracePointKind: 'TracePointKind',
        WhenInputRoleBindingSpec: 'WhenInputRoleBindingSpec',
        WhenInputRoleBindingSpecFacet: 'WhenInputRoleBindingSpecFacet',
        WhileStep: 'WhileStep',
        Workflow: 'Workflow',
        WorkflowEndTracePoint: 'WorkflowEndTracePoint',
        WorkflowFacet: 'WorkflowFacet',
        WorkflowHandle: 'WorkflowHandle',
        WorkflowProvenance: 'WorkflowProvenance',
        WorkflowStartTracePoint: 'WorkflowStartTracePoint',
        WorkflowState: 'WorkflowState',
        WorkflowStateEntry: 'WorkflowStateEntry',
        WorkflowStateEntryByRoleName: 'WorkflowStateEntryByRoleName',
        WorkflowStateEntryKind: 'WorkflowStateEntryKind',
        WorkflowStateFacet: 'WorkflowStateFacet',
        WorkflowTrace: 'WorkflowTrace',
        WorkflowTraceHandle: 'WorkflowTraceHandle',
    },
    Handles: {
        ResourceTypes: {
            TYPE_BaseResource: 'TYPE-BaseResource',
            TYPE_BaseTracePoint: 'TYPE-BaseTracePoint',
            TYPE_Boolean: 'TYPE-Boolean',
            TYPE_BranchStep: 'TYPE-BranchStep',
            TYPE_Case: 'TYPE-Case',
            TYPE_Description: 'TYPE-Description',
            TYPE_DescriptionFacet: 'TYPE-DescriptionFacet',
            TYPE_DocumentationSpec: 'TYPE-DocumentationSpec',
            TYPE_Embedding: 'TYPE-Embedding',
            TYPE_Error: 'TYPE-Error',
            TYPE_ExternalInputPotential: 'TYPE-ExternalInputPotential',
            TYPE_ForStep: 'TYPE-ForStep',
            TYPE_GenesisProvenance: 'TYPE-GenesisProvenance',
            TYPE_Goal: 'TYPE-Goal',
            TYPE_GoalHandle: 'TYPE-GoalHandle',
            TYPE_InputPotential: 'TYPE-InputPotential',
            TYPE_InternalInputPotential: 'TYPE-InternalInputPotential',
            TYPE_JsonScalarLink: 'TYPE-JsonScalarLink',
            TYPE_JsonSchemaObject: 'TYPE-JsonSchemaObject',
            TYPE_LoopCase: 'TYPE-LoopCase',
            TYPE_LoopFeedbackBindingSpec: 'TYPE-LoopFeedbackBindingSpec',
            TYPE_LoopStep: 'TYPE-LoopStep',
            TYPE_MacroStep: 'TYPE-MacroStep',
            TYPE_MacroStepContext: 'TYPE-MacroStepContext',
            TYPE_MacroStepSlot: 'TYPE-MacroStepSlot',
            TYPE_MaterializedResource: 'TYPE-MaterializedResource',
            TYPE_Name: 'TYPE-Name',
            TYPE_NameFacet: 'TYPE-NameFacet',
            TYPE_Natural: 'TYPE-Natural',
            TYPE_Provenance: 'TYPE-Provenance',
            TYPE_ProvenanceFacet: 'TYPE-ProvenanceFacet',
            TYPE_ProvenanceKind: 'TYPE-ProvenanceKind',
            TYPE_Resource: 'TYPE-Resource',
            TYPE_ResourceId: 'TYPE-ResourceId',
            TYPE_ResourcePointer: 'TYPE-ResourcePointer',
            TYPE_ResourceType: 'TYPE-ResourceType',
            TYPE_ResourceTypeHandle: 'TYPE-ResourceTypeHandle',
            TYPE_Role: 'TYPE-Role',
            TYPE_RoleBindingSpec: 'TYPE-RoleBindingSpec',
            TYPE_RoleBindingSpecFacet: 'TYPE-RoleBindingSpecFacet',
            TYPE_RoleByName: 'TYPE-RoleByName',
            TYPE_RoleName: 'TYPE-RoleName',
            TYPE_RoleNameArray: 'TYPE-RoleNameArray',
            TYPE_RoleSpec: 'TYPE-RoleSpec',
            TYPE_RoleSpecFacet: 'TYPE-RoleSpecFacet',
            TYPE_RuntimeProvenance: 'TYPE-RuntimeProvenance',
            TYPE_Step: 'TYPE-Step',
            TYPE_StepArray: 'TYPE-StepArray',
            TYPE_StepArrayArray: 'TYPE-StepArrayArray',
            TYPE_StepKind: 'TYPE-StepKind',
            TYPE_StepKindFacet: 'TYPE-StepKindFacet',
            TYPE_StepPath: 'TYPE-StepPath',
            TYPE_StepPathRelocation: 'TYPE-StepPathRelocation',
            TYPE_StepPathRelocationArray: 'TYPE-StepPathRelocationArray',
            TYPE_StepPathSegment: 'TYPE-StepPathSegment',
            TYPE_StepPathSegmentKind: 'TYPE-StepPathSegmentKind',
            TYPE_StepPathSlot: 'TYPE-StepPathSlot',
            TYPE_StepPathSpec: 'TYPE-StepPathSpec',
            TYPE_StepsByThreadIndexFacet: 'TYPE-StepsByThreadIndexFacet',
            TYPE_StepsFacet: 'TYPE-StepsFacet',
            TYPE_Suite: 'TYPE-Suite',
            TYPE_SuiteIngestorInputSchema: 'TYPE-SuiteIngestorInputSchema',
            TYPE_SuspendedTracePoint: 'TYPE-SuspendedTracePoint',
            TYPE_TickKind: 'TYPE-TickKind',
            TYPE_TickTracePoint: 'TYPE-TickTracePoint',
            TYPE_TimestampedResource: 'TYPE-TimestampedResource',
            TYPE_Tool: 'TYPE-Tool',
            TYPE_ToolHandle: 'TYPE-ToolHandle',
            TYPE_ToolStep: 'TYPE-ToolStep',
            TYPE_ToolStepRoleAddress: 'TYPE-ToolStepRoleAddress',
            TYPE_TracePoint: 'TYPE-TracePoint',
            TYPE_TracePointCounterSnapshot: 'TYPE-TracePointCounterSnapshot',
            TYPE_TracePointDelta: 'TYPE-TracePointDelta',
            TYPE_TracePointKind: 'TYPE-TracePointKind',
            TYPE_WhenInputRoleBindingSpec: 'TYPE-WhenInputRoleBindingSpec',
            TYPE_WhenInputRoleBindingSpecFacet: 'TYPE-WhenInputRoleBindingSpecFacet',
            TYPE_WhileStep: 'TYPE-WhileStep',
            TYPE_Workflow: 'TYPE-Workflow',
            TYPE_WorkflowEndTracePoint: 'TYPE-WorkflowEndTracePoint',
            TYPE_WorkflowFacet: 'TYPE-WorkflowFacet',
            TYPE_WorkflowHandle: 'TYPE-WorkflowHandle',
            TYPE_WorkflowProvenance: 'TYPE-WorkflowProvenance',
            TYPE_WorkflowStartTracePoint: 'TYPE-WorkflowStartTracePoint',
            TYPE_WorkflowState: 'TYPE-WorkflowState',
            TYPE_WorkflowStateEntry: 'TYPE-WorkflowStateEntry',
            TYPE_WorkflowStateEntryByRoleName: 'TYPE-WorkflowStateEntryByRoleName',
            TYPE_WorkflowStateEntryKind: 'TYPE-WorkflowStateEntryKind',
            TYPE_WorkflowStateFacet: 'TYPE-WorkflowStateFacet',
            TYPE_WorkflowTrace: 'TYPE-WorkflowTrace',
            TYPE_WorkflowTraceHandle: 'TYPE-WorkflowTraceHandle',
        },
        Tools: {
            TOOL_Add: 'TOOL-Add',
            TOOL_BooleanIdentity: 'TOOL-BooleanIdentity',
            TOOL_Divide: 'TOOL-Divide',
            TOOL_Identity: 'TOOL-Identity',
            TOOL_LessThan: 'TOOL-LessThan',
            TOOL_LogicalAnd: 'TOOL-LogicalAnd',
            TOOL_LogicalNAnd: 'TOOL-LogicalNAnd',
            TOOL_LogicalNOr: 'TOOL-LogicalNOr',
            TOOL_LogicalNot: 'TOOL-LogicalNot',
            TOOL_LogicalOr: 'TOOL-LogicalOr',
            TOOL_LogicalXNor: 'TOOL-LogicalXNor',
            TOOL_LogicalXOr: 'TOOL-LogicalXOr',
            TOOL_Multiply: 'TOOL-Multiply',
            TOOL_NaturalAdd: 'TOOL-NaturalAdd',
            TOOL_NaturalDivide: 'TOOL-NaturalDivide',
            TOOL_NaturalDouble: 'TOOL-NaturalDouble',
            TOOL_NaturalIdentity: 'TOOL-NaturalIdentity',
            TOOL_NaturalLessThan: 'TOOL-NaturalLessThan',
            TOOL_NaturalMultiply: 'TOOL-NaturalMultiply',
            TOOL_NaturalSubtract: 'TOOL-NaturalSubtract',
            TOOL_Subtract: 'TOOL-Subtract',
        },
    },
    ToolRoleNames: {
        TOOL_Add: {
            AddendOne: 'AddendOne',
            AddendTwo: 'AddendTwo',
            Sum: 'Sum',
        },
        TOOL_Divide: {
            Dividend: 'Dividend',
            Divisor: 'Divisor',
            Quotient: 'Quotient',
            Remainder: 'Remainder',
        },
        TOOL_Identity: {
            In: 'In',
            Out: 'Out',
        },
        TOOL_LessThan: {
            LessThanDecision: 'LessThanDecision',
            LessThanSource: 'LessThanSource',
            LessThanTarget: 'LessThanTarget',
        },
        TOOL_LogicalAnd: {
            OperandOne: 'OperandOne',
            OperandTwo: 'OperandTwo',
            Result: 'Result',
        },
        TOOL_LogicalNAnd: {
            OperandOne: 'OperandOne',
            OperandTwo: 'OperandTwo',
            Result: 'Result',
        },
        TOOL_LogicalNOr: {
            OperandOne: 'OperandOne',
            OperandTwo: 'OperandTwo',
            Result: 'Result',
        },
        TOOL_LogicalNot: {
            Operand: 'Operand',
            Result: 'Result',
        },
        TOOL_LogicalOr: {
            OperandOne: 'OperandOne',
            OperandTwo: 'OperandTwo',
            Result: 'Result',
        },
        TOOL_LogicalXNor: {
            OperandOne: 'OperandOne',
            OperandTwo: 'OperandTwo',
            Result: 'Result',
        },
        TOOL_LogicalXOr: {
            OperandOne: 'OperandOne',
            OperandTwo: 'OperandTwo',
            Result: 'Result',
        },
        TOOL_Multiply: {
            Multiplicand: 'Multiplicand',
            Multiplier: 'Multiplier',
            Product: 'Product',
        },
        TOOL_Subtract: {
            Difference: 'Difference',
            Minuend: 'Minuend',
            Subtrahend: 'Subtrahend',
        },
    },
    Enums: {
        ProvenanceKind: {
            genesis: 'genesis',
            runtime: 'runtime',
            workflow: 'workflow',
        },
        StepKind: {
            tool: 'tool',
            branch: 'branch',
            while: 'while',
            for: 'for',
        },
        StepPathSegmentKind: {
            case: 'case',
            cases: 'cases',
        },
        TickKind: {
            tool_execution: 'tool_execution',
            loop_continuation: 'loop_continuation',
            branch_continuation: 'branch_continuation',
            loop_exit_rebind: 'loop_exit_rebind',
            branch_exit_rebind: 'branch_exit_rebind',
        },
        TracePointKind: {
            workflow_start: 'workflow_start',
            tick: 'tick',
            suspended: 'suspended',
            workflow_end: 'workflow_end',
        },
        WorkflowStateEntryKind: {
            materializedResource: 'materializedResource',
            externalInputPotential: 'externalInputPotential',
            internalInputPotential: 'internalInputPotential',
        },
    }
};
export default CONSTANTS;
